<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 23.445H9.4972C10.1594 23.445 10.7787 23.1172 11.151 22.5696L20.2783 9.1472L17.2156 4.64318C16.942 4.24084 16.4869 4 16.0004 4C15.5138 4 15.0588 4.24084 14.7852 4.64318L2 23.445ZM30 23.4447H22.5028C21.8406 23.4447 21.2213 23.117 20.8489 22.5694L16.7774 16.5818L21.0553 10.2908L30 23.4447ZM24.7793 9.50834C24.227 9.50834 23.7793 9.95606 23.7793 10.5083V12.0119L26.1127 15.4391V10.5083C26.1127 9.95606 25.665 9.50834 25.1127 9.50834H24.7793Z"
      :fill="fill"
    />
    <rect
      x="2"
      y="25.2068"
      width="28"
      height="2.81284"
      rx="1.40642"
      :fill="semanticColorLookup('surface.on-surface')"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsHomeLoan'
})

defineProps({
  fill: {
    type: String,
    default: '#0AC16A'
  }
})
</script>
